import React from "react";
import '../css/main.css';

// const features = [
//   {
//     title: "Audio Description",
//     desc: "Generate context-aware narration that describes visuals, actions, and on-screen text to enhance accessibility for visually impaired users.",
//   },
//   {
//     title: "ISL Gesture Generation",
//     desc: "Convert English or Indian languages into ISL gesture sequences, making video content inclusive for the deaf community.",
//   },
//   {
//     title: "Multilingual Translation",
//     desc: "Support for multiple Indian languages to ensure wider accessibility and reach across diverse linguistic audiences.",
//   },
// ];

const HomeBestFeature = () => {
  return (

        <section
  className="best-feature-section"
  id="bestfeature"
  role="region"
  aria-labelledby="best-feature-heading"
>
      {/* <h2 className="best-feature-title">
        BEST FEATURE
        <span></span>
      </h2> */}

       {/* Section Title */}
      <div className="section-title text-center">
        <h2 id="best-feature-heading">Best Feature</h2>
      </div>
 
      <div className="best-feature-wrapper">
       
        <div className="feature-cards" aria-label="Key features of Chalachitra Vaachana">
       
          {/* {features.map((item, index) => (
            <div className="feature-card" key={index}>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))} */}

  {/* <div className="feature-card">
              <h4>Audio Description</h4>
              <p>Generate context-aware narration that describes visuals, actions, 
                and on-screen text to enhance accessibility for visually impaired users.
</p>
            </div>

  <div className="feature-card">
              <h4>ISL Gesture Generation</h4>
              <p>Convert English or Indian languages into ISL gesture sequences,
                 making video content inclusive for the deaf community."</p>
            </div>
   
  <div className="feature-card">
              <h4>Multilingual Translation</h4>
              <p>Support for multiple Indian languages to ensure wider accessibility 
                and reach across diverse linguistic audiences.,
</p>
            </div> */}
  <ul
      className="feature-cards"
      aria-label="Key features of Chalachitra Vaachana"
    >
      <li className="feature-card" tabIndex="0">
        <h4>Audio Description</h4>
        <p>
          Generate context-aware narration that describes visuals, actions,
          and on-screen text to enhance accessibility for visually impaired users.
        </p>
      </li>

      <li className="feature-card" tabIndex="0">
        <h4>ISL Gesture Generation</h4>
        <p>
          Convert English or Indian languages into ISL gesture sequences,
          making video content inclusive for the deaf community.
        </p>
      </li>

      <li className="feature-card" tabIndex="0">
        <h4>Multilingual Translation</h4>
        <p>
          Support for multiple Indian languages to ensure wider accessibility
          and reach across diverse linguistic audiences.
        </p>
      </li>
    </ul>

        </div>

        
        <div className="feature-image">
      
           <img
            alt="Illustration showing audio description, Indian Sign Language gestures, and multilingual accessibility features"
                  className="img-fluid"
                  src="images/features.jpg"
                />

        </div>

      </div> 


      {/* <div className="best-feature-wrapper">
    <ul className="feature-cards">
      {features.map((item, index) => (
        <li className="feature-card" key={index}>
          <h3>{item.title}</h3>
          <p>{item.desc}</p>
        </li>
      ))}
    </ul>

    <div className="feature-image">
      <img
        src="images/features.jpg"
        className="img-fluid"
        alt="Illustration showing audio description, Indian Sign Language gestures, and multilingual accessibility features"
      />
    </div>
  </div> */}


    </section>
  );
};

export default HomeBestFeature;
